import React from 'react';

export default function VendorCreditGeneral({ setError, error, setForm, form }) {
	return <div>Development In Progress</div>;
}
